import { createModel } from "hox";
import { IEntitySearch, IEntityParams, IEntityDetail, IEntityInsert, IEntityUpdata, IEntityDisable } from "./entityTypes"
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "../../../utils/constants";
import { TablePaginationConfig } from "antd/es/table/interface";
import React, { useState } from "react"
import { filterArrId, Optios, transPgToPagination, findOption } from "../../../utils/utils"
import { IPgProps, ISearchPage } from "../../../types/FmsTypes";
import { PaginationProps } from "antd/es/pagination";
import { globalPrompt } from "../../../components2/YhMessage"
import { entityService } from "./entityService"
import useMdmModel from "../../../model/mdmModel"
import moment, { Moment } from "moment";

export const useEntityModel = createModel(function () {
    const initSearchParams: IEntityParams = {}
    const initDataSource: IEntityDetail[] = []
    const initAddParam: IEntityInsert = { enable: true, branch: "main" }
    const initPage: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //查询条件
    const [searchParam, setSearchParam] = useState<IEntityParams>(initSearchParams)
    //列表数据
    const [dataSource, setDataSource] = useState<IEntityDetail[]>(initDataSource);
    //分页参数
    const [page, setPage] = useState<TablePaginationConfig>(initPage);
    //表格选中行key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    ////表格选中行的数据
    const [selectedRow, setSelectedRow] = useState<IEntityDetail[]>([]);
    //新增参数
    const [addParam, setAddParam] = useState<IEntityInsert>(initAddParam);
    //银行类型
    const [bankList, setBankList] = useState<Optios[]>([])
    //客户类型
    const [entityList, setEntityList] = useState<Optios[]>([])
    const upDataSearchParam = (upDataParam: IEntityParams) => {
        setSearchParam({ ...searchParam, ...upDataParam })
    }
    const resetSearchParam = async () => {
        await setSearchParam(initSearchParams)
        const resetPage = { pageSize: 15, pageNum: 1 }
        await loadData(resetPage, initSearchParams)
    }
    const loadData = async (pages?: ISearchPage, data?: IEntityParams) => {
        const searchParams = data ?? searchParam
        const params = {
            ...searchParams,
            page: {
                pageSize: pages?.pageSize ?? page.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: pages?.pageNum ?? page.current ?? DEFAULT_FIRST_PAGE_NUM
            }
        }
        const { retData } = await entityService.page(params)
        const { records, ...pg } = retData
        setPage(transPgToPagination(pg));
        setDataSource(records)
    }
    const updataAddParam = (updateParam: IEntityInsert) => {
        let newUpdateParam = updateParam
        if ("name" in updateParam) newUpdateParam = { ...updateParam, bentity: updateParam.name }
        setAddParam({ ...addParam, ...newUpdateParam })
    }
    const updataEditParam = (updateParam: IEntityDetail) => {
        let newUpdateParam = updateParam
        if ("name" in updateParam) newUpdateParam = { ...updateParam, bentity: updateParam.name }
        setSelectedRow([{ ...selectedRow[0], ...newUpdateParam }])
    }
    const insertDetail = async (params: IEntityInsert) => {
        const param = {
            ...addParam,
            application:params.application,
            applicationName:params.applicationName,
            sourceApp: "mdm",
            enable: addParam.enable ? 1 : 0,
        }
        const { retData, retMsg } = await entityService.insert(param)
        globalPrompt("message", { type: "success", text: retMsg })
        return retData
    }
    const updataDetail = async (params: IEntityDetail) => {
        const param = {
            ...selectedRow[0],
            application:params.application,
            applicationName:params.applicationName,
            enable: selectedRow[0].enable ? 1 : 0,
        }
        const { retData, retMsg } = await entityService.update(param)
        globalPrompt("message", { type: "success", text: retMsg })
        return retData
    }
    const cutDisabled = async (params: IEntityDetail, checked: boolean) => {
        const param = {
            ...params,
            enable: checked ? 1 : 0,
        }
        const { retData, retMsg } = await entityService.update(param)
        await globalPrompt("message", { type: "success", text: "修改完成" })
        await loadData()
    }
    return {
        searchParam,
        dataSource,
        page,
        selectedRow,
        selectedRowKeys,
        addParam,
        bankList,
        entityList,
        setSearchParam,
        setDataSource,
        setPage,
        setSelectedRowKeys,
        setSelectedRow,
        upDataSearchParam,
        resetSearchParam,
        loadData,
        setAddParam,
        updataAddParam,
        updataEditParam,
        insertDetail,
        updataDetail,
        cutDisabled,
        setBankList,
        setEntityList
    }
});